import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { GrepSearchToolArguments } from 'services/types/ticket';

import MessageWrapper from './MessageWrapper';

interface Props {
  args: string;
}

const GrepSearchToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: GrepSearchToolArguments;

  try {
    parsedArgs = JSON.parse(args) as GrepSearchToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Búsqueda" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Búsqueda con regex" align="left">
      <Box>
        <Box
          sx={{
            mb: 1,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            <SearchIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Patrón de búsqueda:
          </Typography>
          <Paper
            variant="outlined"
            sx={{
              p: 1.5,
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              fontWeight: 'bold',
            }}
          >
            {parsedArgs.query}
          </Paper>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default GrepSearchToolComponent;
